<template>
    <div class="field has-addons lb-project-search-bar">
        <p class="control has-icons-left lb-clean-input is-expanded">
            <input
                v-model="localText"
                :placeholder="placeholder ? placeholder : $t('search')"
                class="input pt-2"
                type="text"
            />
            <span class="icon is-small is-left pt-2">
                <i class="mdi mdi-24px mdi-magnify"></i>
            </span>
        </p>
        <div v-if="hasOptions" class="control">
            <app-dropdown-filter
                :options="options"
                :filter.sync="selectedFilter"
                :active="dropdownActive"
                :allOption="allOption"
                class="is-right lb-clean-input"
                @click="dropdownActive = !dropdownActive"
            />
        </div>
    </div>
</template>

<script>
import AppDropdownFilter from '@/components/AppDropdownFilter';
export default {
    components: {
        AppDropdownFilter,
    },
    model: 'text',
    props: {
        text: {
            type: String,
            default: '',
        },
        filter: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        placeholder: {
            type: String,
            default: '',
        },
        allOption: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            dropdownActive: false,
            selectedFilter: this.filter,
            localText: this.text,
        };
    },
    computed: {
        hasOptions() {
            return this.options.length;
        },
    },
    watch: {
        selectedFilter() {
            this.$emit('update:filter', this.selectedFilter);
        },
        localText() {
            this.$emit('input', this.localText);
        },
    },
};
</script>

<style scoped lang="sass"></style>
